module.exports = __webpack_public_path__ + "static/media/Rectangle Copy 3.3cbb9831.png";